import * as React from "react";
import {
  Link,
  useNavigate,
  useLocation,
} from "react-router-dom";
import _ from 'underscore'

let MessageContext = React.createContext(null);

function Provider(props) {
  let [messageOpen, setMessageOpen] = React.useState(false);
  let [messageContent, setMessageContent] = React.useState(null);
  let [successOpen, setSuccessOpen] = React.useState(false);
  let [successContent, setSuccessContent] = React.useState(null);

  let show = (message) => {
    if( _.isObject(message) ) {
      message = _.values(message).join("\n\r")
    }
    setMessageContent(message)
    setMessageOpen(true)
    setTimeout(() => {
      setMessageContent(null)
      setMessageOpen(false)
    }, 2500)
  }

  let showSuccess = (message='Successful operation') => {
    setSuccessContent(message)
    setSuccessOpen(true)
    setTimeout(() => {
      setSuccessContent(null)
      setSuccessOpen(false)
    }, 2500)
  }
  
  let inject = { 
    messageOpen, 
    messageContent,
    successOpen,
    successContent,
    show, 
    showSuccess,
  }
  return <MessageContext.Provider value={inject}>{props.children}</MessageContext.Provider>;
}

function useMessage() {
  return React.useContext(MessageContext)
}

export default {
  Provider,
  useMessage,
}